'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e$1 from "../defs/ListBullets.es.js";
const e = a.forwardRef((o, s) => /* @__PURE__ */ a.createElement(p, { ref: s, ...o, weights: e$1 }));
e.displayName = "ListBulletsIcon";
const m = e;
export {
  m as ListBullets,
  e as ListBulletsIcon
};
